import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddBoilerSeriesPartsMappingMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";
import Select from "react-select";

function AddBoilerSeriesPartsMappingMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  boilerseriespartsupdatedata,
}) {
  const [boilerSeriesPartsMappingData, setBoilerSeriesPartsMappingData] =
    useState({
      Head: triggerupdate ? boilerseriespartsupdatedata?.head : "",
      SeriesCode: triggerupdate ? boilerseriespartsupdatedata?.seriesCode : "",
      Description: triggerupdate
        ? boilerseriespartsupdatedata?.description
        : "",
      Parts: triggerupdate
        ? boilerseriespartsupdatedata?.parts?.map((x) => x.id) ?? []
        : [],
    });

  const [boilerData, setBoilerData] = useState([]);
  const [boilerSeriesData, setBoilerSeriesData] = useState([]);
  const [partsData, setPartsData] = useState([]);
  const [reloadparts, setreloadparts] = useState(false);
  const [showclonepopup, setshowclonepopup] = useState(false);
  const [boilerPartsMapperCloneData, setBoilerPartsMapperCloneData] = useState({
    BoilerHead: "",
    SeriesCode: "",
    BoilerHeads: [],
    SeriesCodes: [],
  });

  const [refreshparts, setrefreshparts] = useState(false);

  const [rotatereload, setrotatereload] = useState({
    reloadDropdown: false,
    rotateBoilerHeaddropdownicon: false,
    rotateBoilerSeriesdropdownicon: false,
  });

  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState(false);

  useEffect(() => {
    if (triggerupdate) {
      fetchboilerserieshead(boilerSeriesPartsMappingData.Head);
    }
  }, [triggerupdate]);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/UpdateBoilerPartsMapper`,
          {
            id: boilerseriespartsupdatedata.id,
            ...boilerSeriesPartsMappingData,
          }
        )
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.log(error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    } else {
      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper`,
          boilerSeriesPartsMappingData
        )
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.log(error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }

  useEffect(() => {
    setrotatereload({ ...rotatereload, rotateBoilerHeaddropdownicon: true });

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Boiler/GetBoilerDropdown`)
      .then((res) => {
        setBoilerData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({
          ...rotatereload,
          rotateBoilerHeaddropdownicon: false,
        });
      });
  }, [rotatereload.reloadDropdown]);

  function fetchboilerserieshead(boilerhead) {
    setrotatereload({ ...rotatereload, rotateBoilerSeriesdropdownicon: true });
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesByIdOrheadOrSeriesCode?Head=${boilerhead}`
      )
      .then((res) => {
        setBoilerSeriesData(res.data.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatereload({
          ...rotatereload,
          rotateBoilerSeriesdropdownicon: false,
        });
      });
  }

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/GetAllBoilersFromBoilerPartsMapper`
      )
      .then((res) => {
        setBoilerPartsMapperCloneData({
          ...boilerPartsMapperCloneData,
          BoilerHeads: res.data,
        });
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    setreloadparts(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Parts/GetAllPartsDropdown`)
      .then((res) => {
        setPartsData(res.data);
        setreloadparts(false);
      })
      .catch(console.log);
  }, [refreshparts]);

  return (
    <form
      className="add-boiler-series-parts-mapping-master"
      onSubmit={handleSubmit}
      style={{
        width: boilerSeriesPartsMappingData.Parts?.length > 0 && "100%",
      }}
    >
      <blockquote>
        <label>
          Boiler Head{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={boilerData}
            onChange={(values) => {
              if (values) {
                const val = values?.value;
                setBoilerSeriesPartsMappingData({
                  ...boilerSeriesPartsMappingData,
                  Head: val,
                });
                fetchboilerserieshead(val);
                axiosInstance
                  .get(
                    `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/CheckExistingBoilerPartsMapper?head=${val}&seriesCode=${boilerSeriesPartsMappingData.SeriesCode}`
                  )
                  .then((res) => setMessage(res.data))
                  .catch(console.log);
              }
            }}
            value={boilerData?.find(
              (x) => x?.value == boilerSeriesPartsMappingData.Head
            )}
            isClearable
            required
            placeholder="Select Boiler Head"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            menuPlacement="top"
          />

          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateBoilerHeaddropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              setrotatereload({
                ...rotatereload,
                reloadDropdown: !rotatereload.reloadDropdown,
              })
            }
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Series Code{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <select
            onChange={(e) => {
              setBoilerSeriesPartsMappingData({
                ...boilerSeriesPartsMappingData,
                SeriesCode: e.target.value,
              });
              axiosInstance
                .get(
                  `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/CheckExistingBoilerPartsMapper?head=${boilerSeriesPartsMappingData.Head}&seriesCode=${e.target.value}`
                )
                .then((res) => setMessage(res.data))
                .catch(console.log);
            }}
            required
          >
            <option value="">Select Boiler Series</option>
            {boilerSeriesData.map((boilerseries, index) => (
              <option
                key={index}
                value={boilerseries.id}
                selected={
                  boilerSeriesPartsMappingData.SeriesCode === boilerseries.id
                }
              >
                {`${boilerseries.boilerHead} (${boilerseries.seriesCode})`}
              </option>
            ))}
          </select>
          <i
            class={`fa-solid fa-rotate-right ${
              rotatereload.rotateBoilerSeriesdropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() =>
              fetchboilerserieshead(boilerSeriesPartsMappingData.Head)
            }
          ></i>
        </aside>
        <span style={{ color: "red" }}>
          {message &&
            "Boiler Parts With this Head and SeriesCode Already Exists"}
        </span>
      </blockquote>

      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Maximum 400 Characters)"
          onChange={(e) =>
            setBoilerSeriesPartsMappingData({
              ...boilerSeriesPartsMappingData,
              Description: e.target.value,
            })
          }
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
          value={boilerSeriesPartsMappingData.Description}
        ></textarea>
      </blockquote>
      <blockquote>
        <label>Parts</label>
        <aside>
          <Select
            options={partsData}
            isMulti
            onChange={(values) => {
              if (values) {
                setBoilerSeriesPartsMappingData({
                  ...boilerSeriesPartsMappingData,
                  Parts: values?.map((x) => x?.value),
                });
              }
            }}
            closeMenuOnSelect={false}
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            value={partsData?.filter((x) =>
              boilerSeriesPartsMappingData.Parts?.includes(x?.value)
            )}
            hideSelectedOptions={false}
            placeholder="Select Parts"
            menuPlacement="top"
          />
          <i
            class={`fa-solid fa-rotate-right ${reloadparts && "fa-spin"}`}
            title="refresh dropdown"
            onClick={() => setrefreshparts(!refreshparts)}
          ></i>
        </aside>
      </blockquote>
      <blockquote style={{ flexDirection: "row" }}>
        <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
        <button type="button" onClick={() => setshowclonepopup(true)}>
          Clone
        </button>
      </blockquote>
      <CloseForm close={setshowaddform} />
      {showclonepopup && (
        <div className="clone-boiler-series-part-mapping">
          <blockquote>
            <label>Boiler Head</label>
            <select
              onChange={(e) => {
                axiosInstance
                  .get(
                    `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesByIdOrheadOrSeriesCode?Head=${e.target.value}`
                  )
                  .then((res) => {
                    setBoilerPartsMapperCloneData({
                      ...boilerPartsMapperCloneData,
                      BoilerHead: e.target.value,
                      SeriesCodes: res.data.data,
                    });
                  })
                  .catch(console.log);
              }}
            >
              <option value="">Select Boiler Head</option>
              {boilerPartsMapperCloneData.BoilerHeads.map((x) => (
                <option value={x.id}>{x.head}</option>
              ))}
            </select>
          </blockquote>
          <blockquote>
            <label>Boiler Series</label>
            <select
              onChange={(e) =>
                setBoilerPartsMapperCloneData({
                  ...boilerPartsMapperCloneData,
                  SeriesCode: e.target.value,
                })
              }
            >
              <option value="">Select Boiler Series</option>
              {boilerPartsMapperCloneData.SeriesCodes.map((x) => (
                <option value={x.id}>{x.seriesCode}</option>
              ))}
            </select>
          </blockquote>
          <blockquote style={{ flexDirection: "row" }}>
            <button
              type="button"
              onClick={() => {
                axiosInstance
                  .get(
                    `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/GetAllPartsByBoilersAndSeries?boiler=${boilerPartsMapperCloneData.BoilerHead}&series=${boilerPartsMapperCloneData.SeriesCode}`
                  )
                  .then((res) => {
                    setBoilerSeriesPartsMappingData({
                      ...boilerSeriesPartsMappingData,
                      Parts: res.data.map((x) => x.id),
                    });

                    setshowclonepopup(false);
                  })
                  .catch((err) => {
                    toast.error(err.response.data, {
                      position: "bottom-center",
                    });
                    console.log(err);
                  });
              }}
            >
              Submit
            </button>
            <button type="button" onClick={() => setshowclonepopup(false)}>
              Close
            </button>
          </blockquote>
        </div>
      )}
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddBoilerSeriesPartsMappingMaster;
